import React, { Component, useState } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import Card from 'components/Card/Card.jsx';
import Button from '../../components/CustomButton/CustomButton';
import Upload from '../../lib/upload';
import immutable from 'object-path-immutable';
import feathers from './../../feathers';
import auth from '../../libCustom/auth';
import Loading from '../../components/Loading';
import axios from 'axios';
import swal from 'sweetalert';
import SweetAlert from 'react-bootstrap-sweetalert';

const styles = {
  container: {
    backgroundColor: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    padding: '24px',
  },
  title: {
    color: '#374151',
    fontSize: '13px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '16px',
    marginTop: 0,
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  hiddenCheckbox: {
    position: 'absolute',
    opacity: 0,
    width: 0,
    height: 0,
  },
  checkboxBox: {
    width: '24px',
    height: '24px',
    border: '2px solid #d1d5db',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    transition: 'all 0.2s ease',
  },
  checkboxBoxChecked: {
    backgroundColor: '#06b6d4',
    borderColor: '#06b6d4',
  },
  checkIcon: {
    width: '16px',
    height: '16px',
    color: '#ffffff',
  },
  labelText: {
    marginLeft: '12px',
    color: '#374151',
    fontSize: '16px',
  },
};

class HotelsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      formData: {
        urlBot: '',
        name: '',
        address: '',
        description: '',
        imagesWeb: [{ name: '' }],
        imagesUser: [],
        isCheckedAuth: false,
      },
      isChecked: false,
      urlHotel: '',
      loading: false,
      isLoading: false,
      openConfirm: false,
    };
  }

  async componentWillMount() {
    if (this.state.id !== 'create') {
      const { id } = this.props.match.params;
      const getHotel = await feathers.service('hotels').get(id);

      const { name, address, description, urlSource, imagesWeb, auth, images } =
        getHotel;

      let arrayImagesWeb = [{ name: '' }];
      if (imagesWeb.length > 0) {
        arrayImagesWeb = imagesWeb;
      }

      this.setState({
        formData: {
          urlBot: urlSource,
          name,
          address,
          description,
          imagesWeb: arrayImagesWeb,
          isCheckedAuth: auth,
          imagesUser: images,
        },
      });
    }
  }

  handleCheckboxChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, isCheckedAuth: e.target.checked },
    });
  };

  addOption = (index) => (e) => {
    e.preventDefault();
    const newArray = [...this.state.formData.imagesWeb];
    newArray.push({ name: '' });
    this.setState({
      formData: { ...this.state.formData, imagesWeb: newArray },
    });
  };

  removeOption = (index) => (e) => {
    e.preventDefault();
    const newArray = [...this.state.formData.imagesWeb];
    newArray.splice(index, 1);
    this.setState({
      formData: { ...this.state.formData, imagesWeb: newArray },
    });
  };

  handleChange = (value) => {
    let newFormData = immutable.set(this.state.formData, 'urlBot', value);

    this.setState({ formData: newFormData });
  };

  handleSubmitUrlHotel = async () => {
    this.setState({ loading: true });

    const { urlBot } = this.state.formData;
    const hotelRequest = await axios.get(
      `${process.env.REACT_APP_URL_API_HOTELS}/hotels/?url=${urlBot}`
    );

    if (hotelRequest.status === 200 && hotelRequest.data !== '') {
      const { name, address, tagline, images } = hotelRequest.data;

      const formatImgArray =
        images.length > 0
          ? images.map((url) => {
            return { name: url };
          })
          : [];

      this.setState({
        loading: false,
        formData: {
          urlBot,
          auth: this.state.formData.isCheckedAuth,
          name,
          address,
          description: tagline,
          imagesWeb: formatImgArray,
          imagesUser: [],
        },
      });
    } else {
      await swal('Error', 'No fue posible obtener la información del Hotel', {
        icon: 'error',
        timer: 1400,
        buttons: false,
      });
    }
  };

  onChangeSave = (value, name) => {
    let newFormData = immutable.set(this.state.formData, name, value);

    this.setState({ formData: newFormData });
  };

  onAdd = async () => {
    this.setState({ isLoading: true });
    const { franchiseId } = auth.getCurrentUser();

    const {
      urlBot,
      name,
      address,
      description,
      imagesWeb,
      isCheckedAuth,
      imagesUser,
    } = this.state.formData;

    const newData = {
      urlSource: urlBot,
      name,
      address,
      description,
      franchiseId,
      imagesWeb,
      auth: isCheckedAuth,
      images: imagesUser,
    };

    if (imagesWeb && imagesWeb[0] && imagesWeb[0].name === '') {
      newData.imagesWeb = [];
    }

    if (imagesUser.length < 0) {
      delete newData.images;
    }

    if (this.state.id !== 'create') {
      const updateHotel = await feathers
        .service('hotels')
        .patch(this.state.id, newData);

      if (updateHotel) {
        this.setState({ isLoading: false });
        this.props.history.push('/admin/config/hotels');
      }
    } else {
      const createNew = await feathers.service('hotels').create(newData);
      if (createNew) {
        this.setState({ isLoading: false });
        this.props.history.push('/admin/config/hotels');
      }
    }
  };

  chechButtonDisabled = () => {
    const { urlBot, name, address, description, imagesWeb, auth } =
      this.state.formData;

    return !name || !address || !description;
  };

  handleImageUrlChange = (index, value) => {
    const updatedImages = [...this.state.formData.imagesWeb];

    updatedImages[index] = {
      ...updatedImages[index],
      name: value,
      comments: '',
      progress: 0,
      source: 'web',
      selected: true,
    };

    this.setState({
      formData: {
        ...this.state.formData,
        imagesWeb: updatedImages,
      },
    });
  };

  onChange = (files) => {
    let newFiles = JSON.parse(JSON.stringify(files));

    let newFormData = immutable.set(
      this.state.formData,
      'imagesUser',
      newFiles
    );

    this.setState({ formData: newFormData });
  };

  onDeleted = async (confirm = false) => {
    if (confirm) {
      const updateHotel = await feathers
        .service('hotels')
        .patch(this.state.id, { isDeleted: true });

      if (updateHotel) {
        this.setState({ openConfirm: false });
        this.props.history.push('/admin/config/hotels');
      }
    } else {
      this.setState({ openConfirm: true })
    }
  }

  render() {
    const { history } = this.props;
    const { loading, isLoading, formData, id, openConfirm } = this.state;

    const isButtonDisabled = this.chechButtonDisabled();

    if (loading) {
      return <Loading />;
    }

    return (
      <div className="main-content">

        {openConfirm && (
          <SweetAlert
            warning
            style={{ display: 'block' }}
            title="¿Archivar elemento?"
            onConfirm={() => this.onDeleted(true)}
            onCancel={() => this.setState({ openConfirm: false })}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Sí, archivar"
            cancelBtnText="Cancelar"
            showCancel
          >
            El elemento dejará de estar visible en la lista principal, pero podrás consultarlo o reactivarlo después.
          </SweetAlert>
        )}

        <Grid fluid>
          <Row>
            <Col xs={12}>
              <Card
                title={<legend>Editar Hotel</legend>}
                content={
                  <div>
                    <Row>
                      <Col md={9}>
                        <div className="form-group mb-4">
                          <label
                            htmlFor="urlHotel"
                            style={{
                              fontWeight: '400',
                            }}
                          >
                            URL Hotel
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="urlHotel"
                            placeholder="https://example.com"
                            value={formData.urlBot}
                            onChange={(event) =>
                              this.handleChange(event.target.value)
                            }
                          />
                        </div>
                      </Col>

                      <Col md={1} style={{ marginTop: '25px' }}>
                        <Button
                          bsStyle="primary"
                          className="btn-fill"
                          disabled={!formData.urlBot}
                          onClick={() => this.handleSubmitUrlHotel()}
                        >
                          <i className="fa fa-download" /> Conseguir información
                        </Button>
                      </Col>
                    </Row>

                    <hr
                      style={{ border: 'none', borderTop: '2px solid #e5e5e5' }}
                    />

                    <Row>
                      <Col md={12}>
                        <div className="form-group mb-4">
                          <label
                            htmlFor="name"
                            style={{
                              fontWeight: '400',
                            }}
                          >
                            Nombre*
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name}
                            onChange={(event) =>
                              this.onChangeSave(event.target.value, 'name')
                            }
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <div className="form-group mb-4">
                          <label
                            htmlFor="address"
                            style={{
                              fontWeight: '400',
                            }}
                          >
                            Dirección*
                          </label>
                          <input
                            className="form-control"
                            name="address"
                            type="text"
                            value={formData.address}
                            onChange={(event) =>
                              this.onChangeSave(event.target.value, 'address')
                            }
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <div className="form-group mb-4">
                          <label
                            htmlFor="description"
                            style={{
                              fontWeight: '400',
                            }}
                          >
                            Descripción*
                          </label>
                          <textarea
                            className="form-control"
                            name="description"
                            value={formData.description}
                            rows="2"
                            onChange={(event) =>
                              this.onChangeSave(
                                event.target.value,
                                'description'
                              )
                            }
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <div>
                          <legend>Imagenes web</legend>
                        </div>
                      </Col>

                      {formData.imagesWeb.map((option, index) => (
                        <div key={index}>
                          <Col md={10}>
                            <div className="form-group mb-4">
                              <label
                                htmlFor="urlImage"
                                style={{
                                  fontWeight: '400',
                                }}
                              >
                                URL
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="urlImage"
                                value={option.name}
                                onChange={(e) =>
                                  this.handleImageUrlChange(
                                    index,
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          </Col>

                          <Col md={2} style={{ marginTop: 25 }}>
                            {formData.imagesWeb.length > 1 && (
                              <span>
                                <Button
                                  bsStyle="danger"
                                  onClick={this.removeOption(index)}
                                >
                                  -
                                </Button>
                              </span>
                            )}

                            {formData.imagesWeb.length - 1 === index && (
                              <span style={{ paddingLeft: 8 }}>
                                <Button
                                  bsStyle="primary"
                                  onClick={this.addOption(index)}
                                >
                                  +
                                </Button>
                              </span>
                            )}
                          </Col>
                        </div>
                      ))}
                    </Row>

                    <Row>
                      <Col md={12}>
                        <div>
                          <legend>Fotos</legend>
                        </div>
                      </Col>

                      <Col md={12} style={{ marginTop: 30 }}>
                        <Upload
                          label="Imágenes del hotel y cuartos"
                          files={formData.imagesUser}
                          onChange={(item) => this.onChange(item)}
                          multiple={true}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12} style={{ marginTop: 30 }}>
                        <div>
                          <h3 style={styles.title}>
                            Autorizado por Corporativo
                          </h3>
                        </div>
                      </Col>

                      <Col md={12}>
                        <label style={styles.label}>
                          <input
                            type="checkbox"
                            name="auth"
                            checked={formData.isCheckedAuth}
                            onChange={this.handleCheckboxChange}
                            style={styles.hiddenCheckbox}
                          />
                          <div
                            style={{
                              ...styles.checkboxBox,
                              ...(formData.isCheckedAuth
                                ? styles.checkboxBoxChecked
                                : {}),
                            }}
                          >
                            {formData.isCheckedAuth && (
                              <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={styles.checkIcon}
                              >
                                <polyline points="20 6 9 17 4 12"></polyline>
                              </svg>
                            )}
                          </div>
                          <span style={styles.labelText}>
                            Autorizado por corporativo
                          </span>
                        </label>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12} style={{ marginTop: 30 }}>
                        <div>
                          <Button
                            bsStyle="success"
                            type="submit"
                            className="btn-fill"
                            onClick={this.onAdd}
                            disabled={isButtonDisabled || isLoading}
                          >
                            {isLoading ? (
                              <span>
                                Guardando...{' '}
                                <i className="fa fa-spinner fa-spin" />
                              </span>
                            ) : (
                              'Guardar'
                            )}
                          </Button>{' '}
                          <Button
                            bsStyle="default"
                            onClick={() => history.push('/admin/config/hotels')}
                          >
                            Cancelar
                          </Button>

                          <div className="pull-right">
                            {id !== 'create' &&
                              (auth.can('support') || auth.can('matriz')) ? (
                              <Button
                                bsStyle="danger"
                                onClick={() => this.onDeleted(false)}
                              >
                                Archivar Hotel
                              </Button>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default HotelsForm;



// WEBPACK FOOTER //
// ./src/views/Hotels/HotelsForm.jsx